import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconStableVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconStableVoice"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M6.75 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M10.25 7.75V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M13.75 9.75V14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M17.25 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconStableVoice;
